var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-table-list",
      class: { "right-read": _vm.$i18n.locale === "ar" },
    },
    [
      _c("div", { staticClass: "list-fields" }, [
        _c("div", { staticClass: "field field1" }, [
          _vm._v(_vm._s(_vm.$t("lang.wd.phAccount"))),
        ]),
        _c("div", { staticClass: "field field2" }, [
          _vm._v(" " + _vm._s(_vm.$t("lang.dl.income")) + " "),
          _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
        ]),
        _c("div", { staticClass: "field field3" }, [
          _vm._v(" " + _vm._s(_vm.$t("lang.dl.commission")) + " "),
          _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
        ]),
      ]),
      _vm._l(_vm.data, function (item, index) {
        return _c("div", { key: item.index, staticClass: "list-fields" }, [
          _c("div", { staticClass: "bd-field field1 user-info" }, [
            _c("div", { staticClass: "name-id" }, [
              _c("div", { staticClass: "name-wrap" }, [
                _c("span", [_vm._v(_vm._s(item.nickname))]),
                _c("img", {
                  attrs: { src: _vm._f("imgPath")(item.locationFlag) },
                }),
              ]),
              _c(
                "div",
                {
                  staticClass: "id-wrap",
                  on: {
                    click: function ($event) {
                      _vm.handleCopy(
                        item.presentId,
                        _vm.$t("lang.msgCopySuccss")
                      )
                    },
                  },
                },
                [
                  _vm._v(" ID:" + _vm._s(item.presentId) + " "),
                  _c("img", {
                    attrs: {
                      src: require("@/views/P2_Page/Invite/images/copy-gray.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "bd-field field2" }, [
            _vm._v(_vm._s(item.hostIncome)),
          ]),
          _c("div", { staticClass: "bd-field field3" }, [
            _vm._v(_vm._s(item.hostIncomeCommission)),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }